import React from 'react';
import { useAuth } from '../hooks/AuthContext';

const LogoutButton = ({ className = "", showTooltip = true }) => {
    const { logout, oliLogout } = useAuth();
    
    const handleLogout = () => {
        const platform = localStorage.getItem("isLoggedIn") === 'true' ? 'XR' : 'OLI';
        
        if (platform === "OLI") {
            oliLogout();
        } else {
            logout();
        }
    };

    return (
        <button
            onClick={handleLogout}
            className={`inline-flex items-center justify-center w-10 h-10 bg-white/80 backdrop-blur-sm text-gray-600 rounded-xl transition-all duration-200 shadow-sm hover:shadow-md hover:bg-white hover:text-blue-600 border border-gray-200/60 hover:border-blue-200 group ${className}`}
            title={showTooltip ? "Logout" : undefined}
        >
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-5 w-5 transition-transform duration-200 group-hover:scale-110" 
                viewBox="0 0 24 24" 
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/>
                <polyline points="10,17 5,12 10,7"/>
                <line x1="5" y1="12" x2="15" y2="12"/>
            </svg>
        </button>
    );
};

export default LogoutButton;

